export default {
  setPosts: (state, tasks) => {
    state.tasks = tasks;
  }
};
